import BrandsProcessLogs from "../../../components/DataCollection/Brands/BrandsProcessLogs/BrandsProcessLogs";
import { Paper } from "@mui/material";

const BrandsProcessLogScreen = () => {
  return (
    <Paper sx={{ padding: "8px 16px" }}>
      <BrandsProcessLogs />
    </Paper>
  );
};

export default BrandsProcessLogScreen;
